// Setting für die Integrations-Umgebung auf dem Host-Server
export const environment = {
  baseUrl: 'https://easyanlass-dev.sosv.ch',
  production: false,
  environmentName: 'Development',
  environmentColor: 'FireBrick',
};
